import React from "react"
import { styled } from "@mui/material/styles"
import GeniesInfoSection from "components/organisms/WishItemBottomSection/TrueWishSection/GeniesInfoSection"
import MakeWishTrueButton from "components/organisms/WishItemBottomSection/TrueWishSection/MakeWishTrueButton"

type TruedWishSectionProps = {
  id: number;
  cameTrue: boolean;
}

export default function TrueWishSection(props: TruedWishSectionProps) {
  const { cameTrue } = props

  return (
    <Container>
      {cameTrue === true && <GeniesInfoSection/>}
      {cameTrue === false && <MakeWishTrueButton/>}
    </Container>
  )
}

const Container = styled("div")(({ theme }) => ({
  width: "100%",
  height: "40px",
  marginTop: "14px"
}))
